<template>
    <div class="invite_main">
        <div class="invite_header">
            <!-- <div class="icon">
                <div class="eng">广州劳动仲裁院</div>
                <div>GUANGZHOU LABOR ARBITRATION COURT</div>
            </div> -->
            <div class="title">广州劳动人事微仲裁</div>
        </div>
        <div class="invite_content">
            <div class="invite-login">
                <div class="login-title">
                    <div class="title">登  录</div>
                    <div class="bottom-line">Sign in</div>
                </div>
                <el-form :model="invite" :rules="inviterules" @submit.native.prevent ref="invite" class="demo-ruleForm">
                    <el-form-item prop="inviteCode">
                        <el-input class="invite_input" v-model="invite.inviteCode" @keyup.enter="submitForm('invite')" placeholder="请输入邀请码"></el-input>
                    </el-form-item>
                </el-form>
                <div style="display:flex;justify-content: space-between;">
                    <!-- <router-link style="color: #0083c8; cursor:pointer" :to="'./loginWorker'">工作人员登录</router-link> -->
                    <a style="color: #0083c8; cursor:pointer" target="_blank" href="/abilitytest/index.html">视频支持能力检测</a>
                </div>
                <div class="enter" @click="submitForm('invite')">登录</div>
            </div>
        </div>
        <el-dialog
            width="345px"
            title="扫描二维码"
            class="el-dialog-notification"
            :visible.sync="innerVisible"
            :close-on-click-modal=false
            :before-close="handleClose"
            >
            <p>扫码完成实名认证后进入视频</p>
            <div class="code-content">
                <img :src="weixincode" :alt="'人脸认证'">
                <div class="refresh-code" v-if="refreshCode" @click="handleRefreshCode">点击刷新二维码</div>
            </div>
            <p class="invalid-code" v-if="refreshCode">{{refreshName}}</p>
        </el-dialog>
    </div>
</template>
<script>
import config from '@/config/config'
import {inviteEnterWatch} from '@/api/meeting'
import { userLoginByMobile, showRealNameVerifyQRCode, getRealNameVerifyStatus } from '@/api/login.js'
import { setStore, getStore, removeStore, setStoreSession, getStoreSession } from '@/utils/utils.js'
export default {
    data() {
        var validatePhone = (rule, value, callback) => {
            var myreg = /^1[3-9]\d{9}$/;
            if (value === '') {
                callback(new Error('请输入手机号'));
            }else if(!myreg.test(value)) {
                callback(new Error('手机号格式不正确'));
            } else {
                callback();
            }
        };
       return {
            invite: {
                mobilePhone: '',
                inviteCode: ''
            },
            inviterules: {
                mobilePhone: [
                    { required: true, validator: validatePhone, trigger: 'blur' }
                ],
                inviteCode: [
                    { required: true, message: '请输入邀请码', trigger: 'blur' }
                ]
            },
            inviteWatchData: '',
            checked: true,
            innerVisible: false,
            weixincode: '',
            timer: null,
            refreshCode: false,
            refreshName: '二维码已失效'
       }
    },
    mounted() {
    },
    methods: {
        submitForm(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    inviteEnterWatch(this.invite).then((res) => {
                        if (res.data.code === 1000) {
                            let data = res.data.data;
                            this.inviteWatchData = res.data.data;
                            removeStore('loginInfo');
                            removeStore('loginInfouser');
                            removeStore('loginInfoEnterprise'); 
                            setStore('isOutter', 0);  
                            removeStore('appName') 
                            setStore('flk', data.token);
                            setStoreSession('haslogin', 'yes');
                            setStore('loginInfo', data);
                            if(data.notInvitation){
                                this.$router.push({ path: '/agreement', query: { roomid: data.roomId, caseid: data.caseId, 
                                    meetingid: data.meetingId ,token: data.token, memberId: data.memberId, memberName: data.memberName, memberType: data.memberType
                                }})
                            } else {
                                this.ApiShowRealNameVerifyQRCode(data)
                            }
                        } else {
                            this.$message.error(res.data.message)
                            this.reserror = res.data.message;
                            this.showreserror = true;
                                setTimeout(() => {
                                    this.showreserror = false;
                                }, 2000)
                            }
                    }, (err) => {
                        this.$message.error(err)
                    })
                } else {
                    return false;
                }
            })
        },
        ApiShowRealNameVerifyQRCode(jsondata) {
            //显示二维码
            let jsonfile = `appName=gzzc&caseId=${jsondata.caseId}&meetingId=${jsondata.meetingId}&jwtToken=${jsondata.token}`
            this.weixincode = `${config.baseURL}/gzzc/user/showRealNameVerifyQRCode?${jsonfile}`
            this.innerVisible = true
            this.timer = setInterval(() => {
                this.ApigetRealNameVerifyStatus(jsondata)
            }, 6000);
        },
        ApigetRealNameVerifyStatus(data) {
            //循环调用获取签名状态
            getRealNameVerifyStatus().then((res) => {
                switch (res.data.code) {
                    case 1000:
                        this.$router.push({ path: '/agreement', query: { roomid: data.roomId, caseid: data.caseId, 
                            meetingid: data.meetingId ,token: data.token, memberId: data.memberId, memberName: data.memberName, memberType: data.memberType
                        }})
                        break;
                    case 1103:
                        this.refreshCode = true
                        this.refreshName = '二维码已失效'
                        clearInterval(this.timer)
                        break;
                    case 1104:
                        this.refreshCode = true
                        this.refreshName = '认证失败'
                        clearInterval(this.timer)
                        break;
                    case 1005:
                        //结果为空，表示未获取到认证结果，继续等待
                        break;
                    default:
                        break;
                }
            }, (err) => {
                this.$message.error(err)
            })
        },
        goLogin(){
            this.$router.push({path: '/login'});
        },
        handleClose() {
            this.innerVisible = false
        },
        handleRefreshCode() {
            //过期刷新二维码
            this.refreshCode = false
            this.submitForm('invite')
        }
    },
    destroyed(){
        if(this.timer) { //如果定时器在运行则关闭
            clearInterval(this.timer); 
        }
    },
    components:{

    }
}
</script>
<style lang="scss">
.invite_main{
    height: 100%;
    width: 100%;
    background:  url("../../assets/bg.png") no-repeat center top;
    background-size: 100% 100%;
    .invite_header {
        display: flex;
        align-items: center;
        height: 110px;
        width: 85.5%;
        margin: 0 auto;
        color: #fff;
        .icon {
            position: relative;
            margin-right: 40px;
            .eng {
                font-size: 14px;
                letter-spacing: 25px;
            }
        }
        .icon:before {
            content: "";
            position: absolute;
            display: block;
            right: -10px;
            top: 10px;
            width: 1px;
            height: 0;
            border-top: 20px solid #ffffff;
        }
        .title {
            font-size: 28px;
            letter-spacing: 12px;
        }
    }
    .invite_content {
        position: relative;
        height: 80%;
        width: 85.5%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        background:  url("../../assets/bg_content.png") no-repeat center top;
        background-size: 100% 100%;
        .invite-login {
            position: absolute;
            right: 83px;
            height: 500px;
            padding: 0 50px;
            background-color:#fff;
            border-radius: 4px;
            .login-title {
                text-align: center;
                margin-bottom: 50px;
                .title {
                    padding-top: 60px;
                    font-size: 26px;
                    letter-spacing: 5px;
                    font-family: PingFang-SC-Medium;
                }
                .bottom-line {
                    font-size: 14px;
                    font-family: 'PingFang-SC-Light';
                    letter-spacing: 4px;
                }
            }
            .enter {
                margin: 100px auto;
                width: 300px;
                height: 46px;
                line-height: 46px;
                text-align: center;
                background-image: linear-gradient(90deg, 
                    #408cf4 0%, 
                    #3476f0 50%, 
                    #2e6bed 100%), 
                linear-gradient(
                    #0d44b0, 
                    #0d44b0);
                background-blend-mode: normal, 
                    normal;
                box-shadow: 0px 12px 24px 0px 
                    rgba(31, 115, 191, 0.2);
                border-radius: 24px;
                font-size: 18px;
                color: #fff;
                cursor: pointer;
            }
            .el-form-item {
                margin-bottom: 30px;
                .el-input__inner {
                    border: 0;
                    padding: 0;
                    border-bottom: 1px solid #dcdfe6;
                    border-radius: 0;
                }
            }
        }
    }
    .el-dialog-notification {
        .notification {
            padding-bottom: 20px;
        }
        .code-content {
            position: relative;
            .refresh-code {
                position: absolute;
                left: 0;
                top: 0;
                width: 300px;
                height: 300px;
                font-size: 20px;
                line-height: 300px;
                text-align: center;
                color: #0083c8;
                background: rgba(255, 255, 255, 0.9);
                cursor: pointer;
            }
        }
        p {
            text-align: center;
        }
        .invalid-code {
            font-size: 20px;
        }
    }
    .el-button {
        border-radius: 4px;
    }
}

</style>

